import * as React from 'react';

export const toBoolean = (value) =>
  typeof value === 'boolean'
    ? value
    : ['1', 'on', 'yes', 'true'].includes(String(value).toLowerCase());

export function sanitize(string, whitelistedTags = ['var']) {
  return (
    (typeof string === 'string' &&
      string.replace(new RegExp(`<(?!/?${whitelistedTags.join('|/?')})[^>]*>`, 'gmi'), '')) ||
    string
  );
}

export function createSanitizedMarkupForLocalize(string) {
  // eslint-disable-next-line react/no-danger
  return <span dangerouslySetInnerHTML={{ __html: sanitize(string) }} />;
}

export function sanitizeText(string) {
  const whitelistedTags = ['strong', 'var'];
  // eslint-disable-next-line react/no-danger
  return <span dangerouslySetInnerHTML={{ __html: sanitize(string, whitelistedTags) }} />;
}
